import React from "react";

export default function ContactUs() {
  return (
    <div>
      <h1>Here to Help</h1>
      <h2 className="font-weight-normal paddingtop20">
        Technical Support & Sales Hours
      </h2>
      <div className="paddingtop20">
        <h3 className="font-weight-normal">
          Sales: Mon - Fri 9:00am - 7:00pm, Sat/Sun 10:00am - 3:00pm
        </h3>
        <h3 className="font-weight-normal">
          Support: Mon - Fri 9:00am - 7:00pm, Sat/Sun 10:00am - 3:00pm
        </h3>
        <h3 className="font-weight-normal">
          Cancellations: Mon - Fri 10:00am - 5:00pm
        </h3>
      </div>
      <h2 className="font-weight-normal paddingtop20">Contact Information</h2>
      <h3 className="font-weight-normal paddingtop20">
        E-mail: contact@head3dio.com
      </h3>
      <h3 className="font-weight-normal paddingtop20">
        WhatsApp: (+44) 7401769576
      </h3>
      <h3 className="font-weight-normal paddingtop20">
        Mobile: (+44) 7401769576
      </h3>
    </div>
  );
}
